import React from "react";
import References from "../References";

const ReferencesWidget = () => (
  <div className="widget-content-scroll">
    <References />
  </div>
);

export default ReferencesWidget;
